<template>
  <div class="stylist-card-simple jm-bg-white jm-text-center jm-py-4 jm-px-3">
    <div class="jm-d-flex jm-justify-center jm-align-items-center jm-mb-4">
      <stylist-avatar
        data-test="stylist-avatar"
        class="jm-mr-4"
        :src="stylist.imageUrl || defaultProfileImage"
      ></stylist-avatar>
      <div class="jm-direction-column">
        <p class="jm-m-0 jm-mb-1 jm-text-left" data-test="stylist-fullname">
          {{ fullName }}
        </p>
        <stylist-information
          class="jm-text-left"
          data-test="stylist-age"
          :age="stylist.age"
        ></stylist-information>
      </div>
    </div>
    <hr class="jm-bm-4" />
    <text-link data-test="stylist-minisite" :href="stylist.minisite">
      Découvrir le site personnalisé
    </text-link>
  </div>
</template>

<script>
import StylistAvatar from '../molecules/StylistAvatar.vue'
import StylistInformation from '../molecules/StylistInformation.vue'
import TextLink from '../atoms/TextLink.vue'
import defaultProfileImage from '@/assets/images/profile-default.png'

export default {
  name: 'StylistCardSimple',
  components: {
    StylistAvatar,
    StylistInformation,
    TextLink
  },
  props: {
    stylist: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      defaultProfileImage
    }
  },
  computed: {
    fullName() {
      return this.stylist.firstname + ' ' + this.stylist.lastname
    }
  }
}
</script>

<style lang="scss" scoped>
.stylist-card-simple {
  box-sizing: border-box;
  height: 100%;
  margin: 0 auto;
  border-radius: $border-radius-base;
  max-width: $breakpoint-m;
}
</style>
